import React, { useContext, useState, useEffect } from "react";
import { InfoContext } from "../components/InfoContext";
import { PlatformContext } from "../components/Platform/PlatformContext";

const TopScorers: React.FC = () => {
  const { seasons, topScorers, getTeamById } = useContext(InfoContext);
  const [selectedSeasonId, setSelectedSeasonId] = useState("");
  const platform = useContext(PlatformContext);
  const isMobile = !platform?.isDesktop;

  useEffect(() => {
    if (seasons.length > 0) {
      const maxId = Math.max(...seasons.map((season) => season.id));
      setSelectedSeasonId(String(maxId));
    }
  }, [seasons]);

  const selectedSeasonIdInt = parseInt(selectedSeasonId, 10);

  const selectedTopScorers = topScorers.find(
    (season) => season.season_id === selectedSeasonIdInt
  )?.top_scorers || [];

  // Sort scorers by goals in descending order and calculate ranks
  const sortedScorers = [...selectedTopScorers].sort((a, b) => b.goals - a.goals);
  let rank = 1;
  let prevGoals = sortedScorers[0]?.goals;
  const scorersWithRank = sortedScorers.map((scorer, index) => {
    if (index > 0 && scorer.goals < prevGoals) {
      rank = index + 1;
    }
    const currentRank = rank;
    prevGoals = scorer.goals;
    return { ...scorer, rank: currentRank };
  });

  return (
    <div className="p-4 text-white">
      <h2 className="flex justify-center mb-6 mt-4 text-3xl font-semibold text-left text-white">
        Top Scorers
      </h2>

      <form className="flex justify-center text-black mb-8 rounded-xl shadow-md w-full gap-y-4">
        <select
          id="seasonSelect"
          value={selectedSeasonId}
          onChange={(e) => setSelectedSeasonId(e.target.value)}
          className="w-full max-w-32 px-3 py-2 border rounded-xl"
          required
        >
          {seasons.map((season) => (
            <option key={season.id} value={season.id}>
              {season.name}
            </option>
          ))}
        </select>
      </form>

      <div className="flex flex-col min-h-[600px]">
        {scorersWithRank.length > 0 ? (
          <div className="overflow-x-auto max-w-2xl mx-auto">
            <table className="min-w-full bg-white/10 rounded-xl shadow-md table-fixed">
              <thead>
                <tr className="text-left text-white">
                  <th className="py-2 px-4 border-b border-white w-[5%]">Rank</th>
                  <th className="py-2 px-4 border-b border-white w-[45%]">Player</th>
                  <th className="py-2 px-4 border-b border-white w-[10%]">Goals</th>
                  <th className="py-2 px-4 border-b border-white w-[40%]">Team</th>
                </tr>
              </thead>
              <tbody>
                {scorersWithRank.map((scorer, index) => {
                  const team = getTeamById(scorer.team_id);
                  return (
                    <tr key={`scorer-${index}`} className="border-b border-white/20 last:border-b-0">
                      <td className="py-2 px-4 w-[5%]">{scorer.rank}</td>
                      <td className="py-2 px-4 w-[45%]">{scorer.name}</td>
                      <td className="py-2 px-4 w-[10%]">{scorer.goals}</td>
                      <td className="py-2 px-4 w-[40%] flex-col items-center justify-center">
                        {team?.logo_url && (
                          <img
                            src={team.logo_url}
                            alt={team.name}
                            className="w-7 h-7 mr-1 flex-shrink-0"
                          />
                        )}
                        {isMobile ? team?.name_short : team?.name || "Unknown Team"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="flex justify-center items-center h-full">
            <p className="text-white text-lg">
              No top scorers yet for this season.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopScorers;